import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Typography,
  message,
  Form,
  Input,
  Button, Layout, Upload, Select,
  Image, Skeleton,
  List,
  Divider
} from "antd";
import { UploadOutlined, FileTextOutlined, FilePdfOutlined, CloseOutlined } from "@ant-design/icons";
import { FaArrowLeft } from "react-icons/fa";
import { Get } from "../../config/api/get";
import { CONTENT_TYPE } from "../../config/constants";
import { LECTURES, COURSE, UPLOADS_URL } from "../../config/constants/api";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Post } from "../../config/api/post";
import swal from "sweetalert";
import VideoPlayer from "../../components/VideoPlayer2";
import { AiFillDelete } from "react-icons/ai";
import { Delete } from "../../config/api";
const { Option } = Select;

function LectureDetails() {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [lecture, setLecture] = useState(null);
  const [courses, setCourses] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [videoList, setVideoList] = useState([]);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [deletedVideos, setDeletedVideos] = useState([]);
  const [deletedFiles, setDeletedFiles] = useState([]);
  const [deleteThumbnail, setDeleteThumbnail] = useState(false);

  useEffect(() => {
    getLecture();
    getCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCourses = async () => {
    setLoading(true);
    try {
      const response = await Get(COURSE.getAllCourses, token, {
        page: "1",
        limit: "100",
      });
      setLoading(false);
      console.log("response", response);
      if (response?.data?.docs) {
        setCourses(response?.data?.docs);
      } else {
        message.error("Something went wrong!");
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  const getLecture = async () => {
    setLoading(true);
    const res = await Get(`${LECTURES.getLectureById}${id}`, token);

    const lectureData = res.data.lecture;
    setLecture(lectureData);
    
    // Initialize video list from existing videos
    if (lectureData?.fileUrls && Array.isArray(lectureData.fileUrls)) {
      const existingVideos = lectureData.fileUrls.map((url, index) => ({
        uid: `video-${index}-${url}`,
        name: url,
        status: 'done',
        url: UPLOADS_URL + '/' + url,
      }));
      setVideoList(existingVideos);
    } else {
      setVideoList([]);
    }
    
    // Initialize file list from existing files
    if (lectureData?.files && Array.isArray(lectureData.files)) {
      setFileList(createFileList(lectureData.files));
    } else {
      setFileList([]);
    }
    
    setLoading(false);
  };
  const deleteLecture = async () => {
    Delete(LECTURES.deleteLecture + id, token)
      .then((response) => {
        if (response?.status) {
          swal("Success!", "Lecture Deleted Successfully", "success");
          navigate("/lecture-management");
        } else {
          swal("Oops!", response?.message, "error");
        }
      })
      .catch((e) => {
        const message = e?.response?.data?.message || e?.message;
        if (message) {
          swal("Oops!", message, "error");
        }
      });
  };


  const onFinish = (values) => {
    // Validate at least one video remains
    const remainingVideos = videoList.filter(v => !deletedVideos.includes(v.name));
    if (remainingVideos.length === 0 && videoList.length > 0) {
      message.error("At least one video must remain. Cannot delete all videos.");
      return;
    }

    console.log(values);
    const formObject = new FormData();

    // Add new videos (only new ones, not existing)
    const newVideos = videoList.filter(v => v.originFileObj);
    newVideos.forEach((file) => {
      formObject.append("video", file.originFileObj);
    });

    // Add deleted videos array
    if (deletedVideos.length > 0) {
      formObject.append("deletedVideos", JSON.stringify(deletedVideos));
    }

    // Add deleted files array
    if (deletedFiles.length > 0) {
      formObject.append("deletedFiles", JSON.stringify(deletedFiles));
    }

    // Handle thumbnail
    if (deleteThumbnail) {
      formObject.append("deleteThumbnail", "true");
    } else if (thumbnailFile && thumbnailFile.originFileObj) {
      formObject.append("thumbnail", thumbnailFile.originFileObj);
    }

    // Add form values
    for (const key in values) {
      if (key !== "video" && key !== "thumbnail") {
        const item = values[key];
        formObject.append(key, item);
      }
    }

    // Add new files (only new ones)
    const newFiles = fileList.filter((x) => Boolean(x.size));
    newFiles.forEach((file) => {
      formObject.append("files", file.originFileObj);
    });

    Post(
      LECTURES.updateLecture + id,
      formObject,
      token,
      null,
      CONTENT_TYPE.FORM_DATA
    )
      .then((response) => {
        if (response?.data?.status) {
          console.log(response?.data);

          swal("Success!", "Lecture Updated Successfully", "success");
          getLecture();
          setEditMode(false);
          // Reset deletion tracking
          setDeletedVideos([]);
          setDeletedFiles([]);
          setDeleteThumbnail(false);
          setThumbnailFile(null);
        } else {
          swal("Oops!", response.data.message, "error");
        }
      })
      .catch((e) => {});
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const uploadOptions = {
    name: "file",
    multiple: true,
    fileList: fileList,
    onChange(info) {
      const newFileList = [...info.fileList];
      
      // Track deleted files
      const currentFileNames = lecture?.files || [];
      const remainingFileNames = newFileList
        .filter(f => !f.originFileObj) // Existing files don't have originFileObj
        .map(f => f.name);
      const deleted = currentFileNames.filter(f => !remainingFileNames.includes(f));
      setDeletedFiles(deleted);
      
      setFileList(newFileList);
    },
    onRemove(file) {
      // If it's an existing file (no originFileObj), add to deletedFiles
      if (!file.originFileObj && file.name) {
        setDeletedFiles(prev => {
          if (!prev.includes(file.name)) {
            return [...prev, file.name];
          }
          return prev;
        });
      }
    },
    beforeUpload(file) {
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "text/plain",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (!allowedTypes.includes(file.type)) {
        message.error(`${file.name} is not a valid file type.`);
        return Upload.LIST_IGNORE;
      }
      return false; // Prevent auto upload
    },
  };

  const videoUploadOptions = {
    name: "video",
    multiple: true,
    accept: "video/*",
    fileList: videoList,
    beforeUpload: () => false, // Prevent auto upload
    onChange(info) {
      setVideoList(info.fileList);
    },
    onRemove(file) {
      // If it's an existing video (no originFileObj), add to deletedVideos
      if (!file.originFileObj && file.name) {
        setDeletedVideos(prev => {
          if (!prev.includes(file.name)) {
            return [...prev, file.name];
          }
          return prev;
        });
      }
    },
  };

  const thumbnailUploadOptions = {
    name: "thumbnail",
    listType: "picture-card",
    maxCount: 1,
    fileList: thumbnailFile ? [thumbnailFile] : [],
    showUploadList: false,
    beforeUpload: (file) => {
      // Create preview URL for real-time display
      const reader = new FileReader();
      reader.onload = (e) => {
        setThumbnailPreview(e.target.result);
      };
      reader.readAsDataURL(file);
      setThumbnailFile({ ...file, uid: file.uid || Date.now() });
      setDeleteThumbnail(false);
      return false; // Prevent auto upload
    },
    onChange(info) {
      if (info.fileList.length > 0) {
        setThumbnailFile(info.fileList[0]);
        setDeleteThumbnail(false);
      } else {
        setThumbnailFile(null);
        setThumbnailPreview(null);
      }
    },
  };
  return (
    <Layout className="configuration">
      <div className="boxDetails">
        <Row
          className="whiteBackground"
          style={{ backgroundColor: "white", justifyContent: "center" }}
        >
          <Col xs={24} md={22}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                padding: "100px 20px",
              }}
            >
              <Row style={{ padding: "10px 20px" }}>
                <Col
                  xs={24}
                  md={12}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <FaArrowLeft
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                    onClick={() => navigate(-1)}
                  />
                  &emsp;
                  <h1 className="pageTitle" style={{ margin: 0 }}>
                    {editMode ? "Edit Lecture Details" : "View Lecture Details"}
                  </h1>
                </Col>
              </Row>
              <Button
                onClick={deleteLecture}
                type="button"
                style={{
                  color: "#d52727",
                  fontWeight: "bold",
                  fontSize: "16px",
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "auto",
                }}
              >
                <AiFillDelete
                  style={{
                    fontSize: "25px",
                    color: "#d52727",
                    marginLeft: "auto",
                  }}
                />{" "}
                Delete
              </Button>
              <br />

              {loading && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50vh",
                  }}
                >
                  <Skeleton active paragraph={{ rows: 10 }} />
                </div>
              )}

              {!loading && lecture && (
                <>
                  {/* Thumbnail at top - Non-edit mode */}
                  {!editMode && lecture.thumbnail && (
                    <Row style={{ padding: "0 40px", marginBottom: "30px" }}>
                      <Col xs={24}>
                        <Image
                          src={UPLOADS_URL + "/" + lecture.thumbnail}
                          alt="Lecture thumbnail"
                          style={{ 
                            maxWidth: "400px",
                            width: "100%", 
                            height: "auto",
                            display: "block",
                            objectFit: "cover"
                          }}
                          preview={false}
                        />
                      </Col>
                    </Row>
                  )}

                  {/* Lecture Details - Non-edit mode (below thumbnail) */}
                  {!editMode && (
                    <Row style={{ padding: "0 40px", marginBottom: "30px" }}>
                      <Col xs={24}>
                        <Row gutter={[24, 24]}>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Lecture No
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {lecture?.lectureNo}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Title
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {lecture?.title}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Description
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {lecture?.description}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Course
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {lecture?.course?.title}
                            </h5>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {/* Thumbnail at top - Edit mode with upload */}
                  {editMode && (
                    <Row style={{ padding: "0 40px", marginBottom: "30px" }}>
                      <Col xs={24}>
                        <Typography.Title
                          className="fontFamily1"
                          style={{
                            fontSize: "18px",
                            fontWeight: 600,
                            color: "#333d47",
                            marginBottom: 15,
                          }}
                        >
                          Thumbnail
                        </Typography.Title>
                        <Form.Item name="thumbnail" style={{ marginBottom: 0 }}>
                          <div style={{ 
                            width: "100%", 
                            maxWidth: "800px",
                          }}>
                            <Upload.Dragger 
                              {...thumbnailUploadOptions} 
                              maxCount={1}
                              style={{
                                padding: (thumbnailPreview || (lecture.thumbnail && !deleteThumbnail)) ? "0" : "60px 20px",
                                minHeight: (thumbnailPreview || (lecture.thumbnail && !deleteThumbnail)) ? "400px" : "200px"
                              }}
                            >
                              {(thumbnailPreview || (lecture.thumbnail && !deleteThumbnail)) ? (
                                <div style={{ 
                                  position: "relative", 
                                  width: "100%",
                                  height: "400px",
                                  borderRadius: "8px",
                                  overflow: "hidden",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#f5f5f5"
                                }}>
                                  <img
                                    src={thumbnailPreview || (UPLOADS_URL + "/" + lecture.thumbnail)}
                                    alt="Thumbnail"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      width: "auto",
                                      height: "auto",
                                      objectFit: "contain",
                                      display: "block"
                                    }}
                                  />
                                  <Button
                                    type="text"
                                    danger
                                    icon={<CloseOutlined />}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setThumbnailFile(null);
                                      setThumbnailPreview(null);
                                      if (lecture?.thumbnail) {
                                        setDeleteThumbnail(true);
                                      }
                                    }}
                                    style={{
                                      position: "absolute",
                                      top: "8px",
                                      right: "8px",
                                      zIndex: 10,
                                      backgroundColor: "rgba(255, 255, 255, 0.9)",
                                      borderRadius: "50%",
                                      width: "32px",
                                      height: "32px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                    }}
                                  />
                                </div>
                              ) : (
                                <>
                                  <p className="ant-upload-drag-icon">
                                    <UploadOutlined style={{ fontSize: "48px", color: "#1890ff" }} />
                                  </p>
                                  <p className="ant-upload-text" style={{ fontSize: "16px", marginTop: "16px" }}>
                                    Click or drag thumbnail image to this area to upload
                                  </p>
                                  <p className="ant-upload-hint" style={{ fontSize: "14px", color: "#999" }}>
                                    Support for single image upload. Recommended size: 800x400px
                                  </p>
                                </>
                              )}
                            </Upload.Dragger>
                          </div>
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                  {editMode && <Divider style={{ margin: "30px 0" }} />}

                  {/* Inputs below thumbnail - Edit mode */}
                  {editMode && (
                    <Row style={{ padding: "0 40px", marginBottom: "30px" }}>
                      <Col xs={24}>
                        <Row gutter={20}>
                          <Col
                            xs={24}
                            sm={12}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              flexDirection: "column",
                            }}
                          >
                            <Typography.Title
                              className="fontFamily1"
                              style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                color: "black",
                                textAlign: "left",
                                marginBottom: 20,
                              }}
                            >
                              Lecture No :
                            </Typography.Title>

                            <Form.Item
                              name="lectureNo"
                              initialValue={lecture?.lectureNo}
                              style={{ width: "100%" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Please input Lecture No",
                                },
                              ]}
                            >
                              <Input
                                size="large"
                                placeholder="Enter Lecture No"
                                className="signupFormInput"
                              />
                            </Form.Item>
                          </Col>
                          <Col
                            xs={24}
                            sm={12}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              flexDirection: "column",
                            }}
                          >
                            <Typography.Title
                              className="fontFamily1"
                              style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                color: "black",
                                textAlign: "left",
                                marginBottom: 20,
                              }}
                            >
                              Title :
                            </Typography.Title>

                            <Form.Item
                              name="title"
                              initialValue={lecture?.title}
                              style={{ width: "100%" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Please input Lecture title",
                                },
                              ]}
                            >
                              <Input
                                size="large"
                                placeholder="Enter Title"
                                className="signupFormInput"
                              />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row gutter={20}>
                          <Col
                            xs={24}
                            sm={12}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              flexDirection: "column",
                            }}
                          >
                            <Typography.Title
                              className="fontFamily1"
                              style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                color: "black",
                                textAlign: "left",
                                marginBottom: 20,
                              }}
                            >
                              Description:
                            </Typography.Title>

                            <Form.Item
                              name="description"
                              initialValue={lecture?.description}
                              style={{ width: "100%" }}
                              rules={[
                                {
                                  required: true,
                                  message:
                                    "Please input Lecture description",
                                },
                              ]}
                            >
                              <Input
                                size="large"
                                placeholder="Enter Description"
                                className="signupFormInput"
                              />
                            </Form.Item>
                          </Col>
                          <Col
                            xs={24}
                            sm={12}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              flexDirection: "column",
                            }}
                          >
                            <Typography.Title
                              className="fontFamily1"
                              style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                color: "black",
                                textAlign: "left",
                                marginBottom: 20,
                              }}
                            >
                              Course :
                            </Typography.Title>

                            <Form.Item
                              name="course"
                              initialValue={lecture?.course._id}
                              style={{ width: "100%" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Please input lecture course",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Course"
                                className="signupSelectBox"
                              >
                                {courses.map((item) => {
                                  return (
                                    <Option value={item._id}>
                                      {item?.title}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}
                  {editMode && <Divider style={{ margin: "30px 0" }} />}

                  <Row style={{ padding: "0 40px" }}>
                    <Col xs={24}>
                      {!editMode && (
                        <div>
                          {/* Lecture Details Section */}
                          <div style={{ marginBottom: "40px" }}>
                            {/* Details will be shown below in the form section */}
                          </div>
                          
                          {/* Videos Grid */}
                          {(lecture.fileUrls?.length > 0 || lecture.fileUrl) && (
                            <div style={{ marginBottom: "40px" }}>
                              <Typography.Title
                                className="fontFamily1"
                                style={{
                                  fontSize: "20px",
                                  fontWeight: 600,
                                  color: "#333d47",
                                  marginBottom: 20,
                                }}
                              >
                                Videos
                              </Typography.Title>
                              <Row gutter={[16, 16]}>
                                {lecture.fileUrls?.length > 0 ? (
                                  lecture.fileUrls.map((fileUrl, index) => (
                                    <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                      <div style={{
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                        backgroundColor: "#fff"
                                      }}>
                                        <VideoPlayer data={lecture} index={index} />
                                      </div>
                                    </Col>
                                  ))
                                ) : (
                                  <Col xs={24} sm={12} md={8} lg={6}>
                                    <div style={{
                                      borderRadius: "10px",
                                      overflow: "hidden",
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                      backgroundColor: "#fff"
                                    }}>
                                      <VideoPlayer data={lecture} />
                                    </div>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          )}

                          {/* Documents Grid */}
                          {lecture.files && lecture.files.length > 0 && (
                            <div>
                              <Typography.Title
                                className="fontFamily1"
                                style={{
                                  fontSize: "20px",
                                  fontWeight: 600,
                                  color: "#333d47",
                                  marginBottom: 20,
                                }}
                              >
                                Documents
                              </Typography.Title>
                              <Row gutter={[16, 16]}>
                                {lecture.files.map((file, index) => {
                                  const fileExtension = file.split('.').pop()?.toLowerCase();
                                  const isPdf = fileExtension === 'pdf';
                                  const fileName = file.split('/').pop() || file;
                                  return (
                                    <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                      <a
                                        href={UPLOADS_URL + "/" + file}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          display: "block",
                                          textDecoration: "none",
                                          color: "inherit"
                                        }}
                                      >
                                        <div style={{
                                          padding: "20px",
                                          backgroundColor: "#fff",
                                          borderRadius: "10px",
                                          border: "1px solid #e8e8e8",
                                          textAlign: "center",
                                          transition: "all 0.3s ease",
                                          cursor: "pointer",
                                          height: "100%",
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                          justifyContent: "center"
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.borderColor = "#1890ff";
                                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(24,144,255,0.2)";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.borderColor = "#e8e8e8";
                                          e.currentTarget.style.boxShadow = "none";
                                        }}
                                        >
                                          {isPdf ? (
                                            <FilePdfOutlined style={{ fontSize: "48px", color: "#ff4d4f", marginBottom: "12px" }} />
                                          ) : (
                                            <FileTextOutlined style={{ fontSize: "48px", color: "#1890ff", marginBottom: "12px" }} />
                                          )}
                                          <Typography.Text
                                            style={{
                                              display: "block",
                                              fontSize: "14px",
                                              fontWeight: 500,
                                              color: "#333",
                                              wordBreak: "break-word",
                                              textAlign: "center"
                                            }}
                                          >
                                            {fileName}
                                          </Typography.Text>
                                        </div>
                                      </a>
                                    </Col>
                                  );
                                })}
                              </Row>
                            </div>
                          )}
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Form
                    layout="vertical"
                    name="basic"
                    className="contactForm"
                    labelCol={{
                      span: 0,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                    initialValues={{
                      remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                  >
                    <Row style={{ padding: "20px" }}>
                      <Col xs={24}>
                        {editMode && (
                          <>
                            {/* Videos Grid */}
                            <Row gutter={30} style={{ padding: "0 20px", marginBottom: "30px" }}>
                              <Col xs={24}>
                                <Typography.Title
                                  className="fontFamily1"
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    color: "#333d47",
                                    marginBottom: 20,
                                  }}
                                >
                                  Videos <span style={{ color: "red" }}>*</span>
                                </Typography.Title>
                                
                                {/* Videos Grid */}
                                {videoList.length > 0 && (
                                  <Row gutter={[16, 16]} style={{ marginBottom: "20px", width: "100%" }}>
                                    {videoList.map((video, idx) => {
                                      const isDeleted = deletedVideos.includes(video.name);
                                      return (
                                        <Col xs={24} sm={12} md={6} lg={6} key={video.uid || idx}>
                                          <div style={{
                                            position: "relative",
                                            borderRadius: "10px",
                                            overflow: "hidden",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                            backgroundColor: "#fff",
                                            opacity: isDeleted ? 0.5 : 1
                                          }}>
                                            {/* Close Icon */}
                                            <Button
                                              type="text"
                                              danger
                                              icon={<CloseOutlined />}
                                              onClick={() => {
                                                if (!video.originFileObj && video.name) {
                                                  setDeletedVideos(prev => {
                                                    if (!prev.includes(video.name)) {
                                                      return [...prev, video.name];
                                                    }
                                                    return prev;
                                                  });
                                                } else {
                                                  setVideoList(prev => prev.filter((_, i) => i !== idx));
                                                }
                                              }}
                                              style={{
                                                position: "absolute",
                                                top: "8px",
                                                right: "8px",
                                                zIndex: 10,
                                                backgroundColor: "rgba(255, 255, 255, 0.9)",
                                                borderRadius: "50%",
                                                width: "32px",
                                                height: "32px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                              }}
                                            />
                                            {video.url && !video.originFileObj ? (
                                              <VideoPlayer 
                                                data={{ 
                                                  ...lecture,
                                                  fileUrls: lecture?.fileUrls || [],
                                                  videoThumbnails: lecture?.videoThumbnails || []
                                                }} 
                                                index={lecture?.fileUrls?.indexOf(video.name)} 
                                              />
                                            ) : video.originFileObj ? (
                                              (() => {
                                                const blobUrl = URL.createObjectURL(video.originFileObj);
                                                return (
                                                  <VideoPlayer 
                                                    data={{ 
                                                      fileUrl: blobUrl,
                                                      fileUrls: [blobUrl]
                                                    }} 
                                                  />
                                                );
                                              })()
                                            ) : (
                                              <div style={{
                                                paddingBottom: "56.25%",
                                                height: 0,
                                                backgroundColor: "#000",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "#fff"
                                              }}>
                                                <Typography.Text style={{ color: "#fff" }}>
                                                  {video.name || `Video ${idx + 1}`}
                                                </Typography.Text>
                                              </div>
                                            )}
                                          </div>
                                        </Col>
                                      );
                                    })}
                                  </Row>
                                )}
                                
                                {/* Add More Videos Button - Centered */}
                                <div style={{ textAlign: "center", marginTop: "20px" }}>
                                  <Form.Item name="videos" style={{ marginBottom: 0 }}>
                                    <Upload {...videoUploadOptions} fileList={videoList} showUploadList={false}>
                                      <Button 
                                        icon={<UploadOutlined />}
                                        type="primary"
                                        size="large"
                                        style={{
                                          borderRadius: "6px",
                                          padding: "0 30px"
                                        }}
                                      >
                                        {videoList.length > 0 ? "Add More Videos" : "Add Videos"}
                                      </Button>
                                    </Upload>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>

                            {/* Documents Grid */}
                            <Row gutter={30} style={{ padding: "0 20px", marginBottom: "30px" }}>
                              <Col xs={24}>
                                <Typography.Title
                                  className="fontFamily1"
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    color: "#333d47",
                                    marginBottom: 20,
                                  }}
                                >
                                  Documents
                                </Typography.Title>
                                
                                {/* Documents Grid */}
                                {fileList.length > 0 && (
                                  <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
                                    {fileList.map((file, idx) => {
                                      const isDeleted = deletedFiles.includes(file.name);
                                      const fileExtension = file.name?.split('.').pop()?.toLowerCase();
                                      const isPdf = fileExtension === 'pdf';
                                      return (
                                        <Col xs={24} sm={12} md={8} lg={6} key={file.uid || idx}>
                                          <div style={{
                                            position: "relative",
                                            padding: "20px",
                                            backgroundColor: isDeleted ? "#fff1f0" : "#fff",
                                            borderRadius: "10px",
                                            border: `1px solid ${isDeleted ? "#ffccc7" : "#e8e8e8"}`,
                                            textAlign: "center",
                                            opacity: isDeleted ? 0.5 : 1,
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center"
                                          }}>
                                            {/* Close Icon */}
                                            <Button
                                              type="text"
                                              danger
                                              icon={<CloseOutlined />}
                                              onClick={() => {
                                                if (!file.originFileObj && file.name) {
                                                  setDeletedFiles(prev => {
                                                    if (!prev.includes(file.name)) {
                                                      return [...prev, file.name];
                                                    }
                                                    return prev;
                                                  });
                                                } else {
                                                  setFileList(prev => prev.filter((_, i) => i !== idx));
                                                }
                                              }}
                                              style={{
                                                position: "absolute",
                                                top: "8px",
                                                right: "8px",
                                                zIndex: 10,
                                                backgroundColor: "rgba(255, 255, 255, 0.9)",
                                                borderRadius: "50%",
                                                width: "32px",
                                                height: "32px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                              }}
                                            />
                                            {isPdf ? (
                                              <FilePdfOutlined style={{ fontSize: "48px", color: "#ff4d4f", marginBottom: "12px" }} />
                                            ) : (
                                              <FileTextOutlined style={{ fontSize: "48px", color: "#1890ff", marginBottom: "12px" }} />
                                            )}
                                            <Typography.Text
                                              style={{
                                                display: "block",
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                color: "#333",
                                                wordBreak: "break-word",
                                                textAlign: "center"
                                              }}
                                            >
                                              {file.name}
                                            </Typography.Text>
                                          </div>
                                        </Col>
                                      );
                                    })}
                                  </Row>
                                )}
                                
                                {/* Add Documents Button - Centered */}
                                <div style={{ textAlign: "center" }}>
                                  <Upload {...uploadOptions} fileList={fileList} showUploadList={false}>
                                    <Button 
                                      icon={<UploadOutlined />}
                                      size="large"
                                      style={{
                                        borderRadius: "6px",
                                        padding: "0 30px"
                                      }}
                                    >
                                      {fileList.length > 0 ? "Add More Documents" : "Add Documents"}
                                    </Button>
                                  </Upload>
                                </div>
                              </Col>
                            </Row>
                          </>
                        )}

                        <br />

                        {editMode ? (
                          <>
                            {/* Inputs are now shown above, below thumbnail */}
                          </>
                        ) : (
                          <>
                            {/* Lecture details are now shown above in non-edit mode, below thumbnail */}
                          </>
                        )}

                        <Row style={{ marginTop: 30 }}>
                          {editMode && (
                            <>
                              {" "}
                              <Button
                                type="primary"
                                htmlType="submit"
                                className="loginButton"
                              >
                                Save Changes
                              </Button>
                              &emsp;
                              <Button
                                className="fontFamily1"
                                style={{
                                  marginTop: "0px",
                                  padding: "10px 30px",
                                  cursor: "pointer",
                                  color: "black",
                                  borderRadius: "5px",
                                  height: "auto",
                                  border: "1px solid #203657",
                                  fontWeight: "bold",
                                }}
                                ghost
                                size="large"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setEditMode(false);
                                  // Reset deletion tracking when canceling
                                  setDeletedVideos([]);
                                  setDeletedFiles([]);
                                  setDeleteThumbnail(false);
                                  setThumbnailFile(null);
                                  // Reload lecture data to reset lists
                                  getLecture();
                                }}
                              >
                                Cancel
                              </Button>
                            </>
                          )}
                          {!editMode && (
                            <Row justify={"center"}>
                              <Col style={{ textAlign: "center" }}>
                                <Button
                                  type="primary"
                                  htmlType="button"
                                  className="loginButton"
                                  onClick={() => setEditMode(true)}
                                >
                                  Edit Lecture
                                </Button>
                              </Col>
                            </Row>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </>
              )}

              <br />
              <br />
            </div>
          </Col>
        </Row>
      </div>

      <br />
      <br />
    </Layout>
  );
}
export default LectureDetails;

const RecordViewer = ({ pdfLinks }) => { // eslint-disable-line no-unused-vars
  return (
    <List
      bordered
      dataSource={pdfLinks}
      renderItem={(item) => (
        <List.Item>
          <a
            href={UPLOADS_URL + "/" + item}
            target="_blank"
            rel="noopener noreferrer"
          >
            {(item.split(".")[1] || "") +
              (item.split(".")[2] ? "." + item.split(".")[2] : item)}
          </a>
        </List.Item>
      )}
    />
  );
};

const createFileList = (arr) => {
  try {
    return arr?.map((item) => ({
      uid: item,
      name: item,
      status: "done",
      url: UPLOADS_URL + item,
      percent: 100,
    }));
  } catch (error) {
    console.log(error);
  }
};
